export default "/assets/sent_swooshs-c955981579df96f5276e98eeccbd640a09113fd0e81785095e2c8eb277ad2cc2.svg";